import i18next from "i18next";
import { withBreadCrumbs } from "lego-gui-lib";
import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { PropertySchema } from "./schema";
import { CreateView, IndexView, ShowView, TextField } from "lego-gui-lib/lib";
import { ForeignPropertyValueColumns } from "../propertyValue/schema";
import { createStyles, Theme, withStyles } from "@material-ui/core";
import get from "lodash/get";
import {
  RemotePropertyValueEdit,
  RemotePropertyValueCreate
} from "../propertyValue/RemotePropertyValueViews";
import { ParentRoute } from "../../core/model/parent";
import { observer } from "mobx-react-lite";

export const Property = {
  url: "/properties",
  handler: (props: RouteComponentProps<any>) => {
    const title = i18next.t("hns:property:domain_plural");
    const baseUrl = props.match.url;
    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute
          path={baseUrl + "/:propertyName"}
          dataSourceName={"property"}
          idField={"propertyName"}
        />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route
            path={baseUrl + "/:propertyName/propertyValues/create"}
            component={RemotePropertyValueCreate}
          />
          <Route
            path={baseUrl + "/:propertyName/propertyValues/:id"}
            component={RemotePropertyValueEdit}
          />
          <Route path={baseUrl + "/:propertyName"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("property", "propertyValueNested", "i18n")(observer(comp));

const IndexViewSchema = PropertySchema.extend({
  description: { type: TextField() }
});

export const Index = injectDataSource(({ property, i18n, ...rest }: any) => {
  const title = i18n.t("hns:property:domain", { count: 2 });
  return (
    <IndexView
      dataSource={property.listDataSource}
      {...rest}
      title={title}
      toolbarButtons={{ delete: false, export: true }}
      rowButtons={{ edit: true, delete: false, copy: false, export: true }}
      titleButtons={() => <></>}
      columns={IndexViewSchema}
    />
  );
});

const CreateViewSchema = PropertySchema.extend({
  updated: false
});
export const Create = injectDataSource(
  ({ property, match, i18n, ...rest }: any) => {
    const title = i18n.t("common:create", { domain: "hns:property:domain" });
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={property.oneDataSource}
        {...rest}
        title={title}
        fields={CreateViewSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const showWithListsStyles = (theme: Theme) =>
  createStyles({
    firstLine: {
      display: "grid",
      gridTemplateColumns: "35% 62%",
      columnGap: "3%",
      gridColumnGap: `${theme.spacing(3)}`,

      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns: "100%"
      }
    },
    secondLine: {
      display: "grid",
      marginTop: "20px",
      gridTemplateColumns: "100%",
      gridColumnGap: `${theme.spacing(3)}`,

      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns: "100%"
      }
    },
    gridItem: {}
  });

export const Show = withStyles(showWithListsStyles)(
  injectDataSource((props: any) => {
    const {
      property,
      propertyValueNested,
      classes,
      match,
      i18n,
      ...rest
    } = props;
    const title = i18n.t("common:edit", { domain: "hns:property:domain" });
    const titleValue = i18n.t("hns:propertyValue:domain", { count: 2 });
    const baseUrl = match.url;
    const showCreate = get(property, "oneDataSource.one.isList");
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/edit", children: title },
      <>
        <div className={classes.firstLine}>
          <div className="props.classes.gridItem">
            <ShowView
              preloadData={false}
              dataSource={property.oneDataSource}
              title={title}
              fields={PropertySchema}
              id={match.params}
              onlyView={true}
              hideDeleteButton={true}
              goBack={() => history.goBack()}
            />
          </div>
          <div className={classes.secondLine}>
            <IndexView
              dataSource={propertyValueNested.listDataSource}
              {...rest}
              toolbarButtons={{ delete: true, export: true }}
              rowButtons={{
                edit: true,
                delete: showCreate,
                copy: false,
                export: true
              }}
              titleButtons={() => (!showCreate ? <></> : null)}
              title={titleValue}
              baseUrl="/propertyValues"
              columns={ForeignPropertyValueColumns}
              fixedParams={{
                filters: [
                  {
                    field: "propertyName",
                    value: props.match.params.propertyName
                  }
                ]
              }}
            />
          </div>
        </div>
      </>
    );
  })
);
